<div class="content">
    <div class="header">
        <h2>New Arrivals</h2>
        <a routerLink="/collection/{{newArrivalsNo}}" aria-label="New Lace Products">View All
            <mat-icon fontSet="material-symbols-outlined" inline>arrow_forward</mat-icon>
        </a>
    </div>
    <div class="items">
        @for (item of items; track $index) {
        <app-product-list-item [data]="item" [showTitle]="false" showleft
            [showDelay]="50+100*$index"></app-product-list-item>
        }
    </div>
</div>